export default __webpack_public_path__ + "static/new-footer-logo-cropped-db1c4cf4b7fbcaf936342826ad5ff489.png";